module.exports = __webpack_public_path__ + "static/ya-ff4a86ca3b11a1d9fecfffff628512c1.png";